import { useQueryClient } from 'react-query';
import QUERY_CACHE_KEY from '@constants/QueryCacheKey';
import useApiMutation from './useApiMutation';

function useDeleteEventMutation(id, options) {
  const queryClient = useQueryClient();

  return useApiMutation('delete', `/v1/events/${id}/delete`, {
    ...options,
    onSuccess: async (res, ...args) => {
      queryClient.invalidateQueries(QUERY_CACHE_KEY.event);
      queryClient.invalidateQueries(QUERY_CACHE_KEY.feed);
      queryClient.invalidateQueries(QUERY_CACHE_KEY.feedDetailed);

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(res, ...args);
      }
    },
  });
}

export default useDeleteEventMutation;
